export function formatCampaignMoney(cents: number, currency?: string): string {
  const amount = cents / 100;
  if (!currency) return `${amount.toFixed(2)} (account currency)`;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}
